import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Button from "../../component/ui/Button"; // Adjust path if needed
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const CommonCTA = ({
  heading,
  description,
  // Button Props
  showButton = true,
  buttonText = "Learn More",
  buttonProps = {}, // Allows passing any specific props to your custom Button component
  // Styling Props
  backgroundColor = "#9FC46D",
  textColor = "text-text-primary", // Assuming this is a tailwind class in your config
  className = "",
}) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const textElements = gsap.utils.toArray(".animated-text-content");

      textElements.forEach((element, index) => {
        // Set Initial State
        gsap.set(element, {
          y: 25,
          opacity: 0,
          clipPath: "inset(100% 0 0% 0)",
        });

        // Animation Timeline
        gsap.to(element, {
          y: 0,
          opacity: 1,
          clipPath: "inset(0% 0 0% 0)",
          duration: 1,
          ease: "power2.out",
          delay: index * 0.1,
          scrollTrigger: {
            trigger: element.closest(".cta-container"),
            start: "top 85%",
            end: "center 60%",
            scrub: 1,
          },
        });
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`w-full mb-[40px] 2xl:mb-[80px] font-[Sora] ${className}`}
    >
      <div className="max-w-[1612px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-row justify-center items-center w-full">
          {/* Container with dynamic background */}
          <div
            className="cta-container rounded-[25px] 2xl:rounded-[50px] px-[27px] 2xl:px-[54px] py-[27px] 2xl:py-[54px] w-full"
            style={{ backgroundColor: backgroundColor }}
          >
            <div className="flex flex-col gap-[10px] 2xl:gap-[20px] justify-start items-center w-full">
              {/* 1. Heading */}
              {heading && (
                <h2
                  className={`text-[20px] 2xl:text-[60px] font-bold text-center ${textColor} animated-text-content`}
                >
                  {heading}
                </h2>
              )}

              {/* 2. Description */}
              {description && (
                <p
                  className={`text-[16px] 2xl:text-[24px] font-normal text-center w-full lg:w-3/4 ${textColor} animated-text-content`}
                >
                  {description}
                </p>
              )}

              {/* 3. Button Wrapper */}
              {showButton && (
                <div className="animated-text-content">
                  <Link to="/contact">
                    <Button
                      text={buttonText}
                      // Default Styling (can be overridden via buttonProps)
                      text_font_size="16"
                      text_font_family="Sora"
                      text_font_weight="700"
                      text_line_height="20px"
                      text_text_align="center"
                      text_color="white"
                      fill_background_color="#1C233A"
                      border_border_radius="30px"
                      border_border="none"
                      padding="6px 17px"
                      className="w-auto text-[16px] sm:text-[20px] 2xl:text-[24px] leading-[20px] sm:leading-[25px] 2xl:leading-[31px] py-[6px] px-[17px] sm:py-[9px] sm:px-[25px] 2xl:py-[12px] 2xl:px-[34px]"
                      // Spread custom overrides
                      {...buttonProps}
                    />
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommonCTA;
